<div class="row justify-content-center mb-4">
  @for (card of cards; track $index) {
  <div class="col-12 col-md-6 col-lg-3">
    <groundworks-metrics-card [metrics]="card.metrics" [state]="card.state" />
  </div>
  }
</div>
